import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const Edit = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 10 10" fill="none" {...props}>
      <path
        d="M1.51893 6.65984L1.15394 7.89922L0.957165 8.5689C0.917493 8.70379 0.953992 8.8482 1.05238 8.94658C1.15077 9.04497 1.29518 9.08147 1.42848 9.04339L2.09974 8.84502L3.33912 8.48003C3.5359 8.4229 3.71522 8.32293 3.86915 8.18804C3.89137 8.169 3.912 8.14837 3.93263 8.12774L8.76001 3.30194C9.10755 2.9544 9.15039 2.41961 8.89014 2.02447C8.85364 1.96893 8.80921 1.91498 8.76001 1.86578L8.13477 1.23895C7.73804 0.842224 7.09534 0.842224 6.69861 1.23895L1.87123 6.06634C1.70619 6.23138 1.58558 6.43609 1.51893 6.65984ZM2.24891 6.87408C2.27589 6.78521 2.32032 6.70269 2.38221 6.63287C2.39173 6.62335 2.39967 6.61382 2.40919 6.6043L6.03529 2.97979L7.01917 3.96368L3.39466 7.58977C3.32008 7.66436 3.22645 7.7199 3.12489 7.75005L2.75355 7.85955L1.88392 8.11504L2.13942 7.24541L2.24891 6.87408Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
